import { render, staticRenderFns } from "./origin.vue?vue&type=template&id=ff7bdeda&scoped=true&"
import script from "./origin.vue?vue&type=script&lang=js&"
export * from "./origin.vue?vue&type=script&lang=js&"
import style0 from "./origin.vue?vue&type=style&index=0&id=ff7bdeda&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7bdeda",
  null
  
)

export default component.exports